<script setup>
const localePath = useLocalePath()
</script>

<script>
export default defineComponent({
  computed: {
    availableLocales() {
      return this.$i18n.locales.filter(i => i.code !== this.$i18n.locale)
    },
  },
})
</script>

<template>
  <v-footer
    class="footer d-flex justify-center bg-vm-grey-2"
  >
    <div>
      <nuxt-link
        :to="localePath('/imprint')"
        data-nav-id="footer_imprint"
      >
        {{ $t('layout.footer.imprint') }}
      </nuxt-link>
    </div>
    <div>
      <nuxt-link
        :to="localePath('/agb')"
        data-nav-id="footer_agb"
      >
        {{ $t('layout.footer.agb') }}
      </nuxt-link>
    </div>
    <div>
      <nuxt-link
        :to="localePath('/datasecurity')"
        data-nav-id="footer_privacy"
      >
        {{ $t('layout.footer.dataPolicy') }}
      </nuxt-link>
    </div>
  </v-footer>
</template>

<style lang="scss">
.footer {
  padding: 24px;
  gap: 0;

  > div:not(:last-child)::after {
    content: '·';
    margin: 0 12px;
  }
}
</style>
